export default __webpack_public_path__ + "static/GT-America-Standard-Bold-Italic-0e82c2cc31830726fbb57b17cde2c549.woff";